import React from 'react';
import { Modal, Spin, Icon } from 'antd';

import SharedTools from '../../lib/SharedTools';

export default class AttendanceCalendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      calendar: [],
      // semester: props.semester,
      // setAttendance: 
    }

  }

  componentDidMount() {
    this.toolCalendar(this.props.startDate, this.props.endDate, this.props.days);
  }

  componentWillReceiveProps(newProps) {
    this.toolCalendar(newProps.startDate, newProps.endDate, newProps.days);
  }

  toolCalendar(startDate, endDate, days = []) {
    let start_month = new Date(startDate).getMonth(), end_month = new Date(endDate).getMonth();
    let start_year = new Date(startDate).getFullYear(), end_year = new Date(endDate).getFullYear();
    
    let daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    let calendar = [];

    if (start_year == end_year && start_month <= end_month) {
      if ((start_year % 4 === 0 && start_year % 100 !== 0) || start_year % 400 === 0) {
        daysInMonth[1] = 29
      }
      let monthData = daysInMonth.slice(start_month, end_month + 1);
      monthData.forEach((day, index) => {
        let year = start_year;
        let month = (start_month + 1 + index) % 12 == 0 ? 12 : (start_month + 1 + index) % 12;
        let data = days.filter((item) => item.year == year && item.month == month);
        calendar[index] = {
          month,
          year,
          days: this.toolMonthDays(day, data),
          start_week: this.toolStartDays(year, month)
        }
      })

    } else if (start_year < end_year) {
      let monthData1 = [], monthData2 = [];
      if (start_month < 2) {
        if ((start_year % 4 === 0 && start_year % 100 !== 0) || start_year % 400 === 0) {
          daysInMonth[1] = 29
        }
      }
      monthData1 = daysInMonth.slice(start_month, 12);

      if (end_month > 0) {
        if ((end_year % 4 === 0 && end_year % 100 !== 0) || end_year % 400 === 0) {
          daysInMonth[1] = 29
        } else {
          daysInMonth[1] = 28
        }
      }
      monthData2 = daysInMonth.slice(0, end_month + 1);

      let monthData = monthData1.concat(monthData2);
      monthData.forEach((day, index) => {
        let year = (start_month + 1 + index) > 12 ? end_year : start_year;
        let month = (start_month + 1 + index) % 12 == 0 ? 12 : (start_month + 1 + index) % 12;
        let data = days.filter((item) => item.year == year && item.month == month);
        calendar[index] = {
          month,
          year,
          days: this.toolMonthDays(day, data),
          start_week: this.toolStartDays(year, month)
        }
      })
    }

    this.setState({
      calendar
    })
  }

  toolMonthDays(day, data) {
    let days = []
    for (let i = 0; i < day; i++) {
      let obj = data.find((item) => item.day == i + 1);
      if (!obj) {
        days.push({day: i + 1, should_clock_on: false});
      } else {
        let tag = '';
        if (obj.should_clock_on) {
          if (obj.is_record) {
            if (obj.is_absence) {
              // tag += '未到';
              if (obj.absence_reason) {
                tag += obj.absence_reason.description.length > 8 ? obj.absence_reason.description.substring(0, 8) + '...' : obj.absence_reason.description;
              } else {
                tag += '未到';
              }
            } else {
              if (obj.is_late && obj.is_leave_early) {
                tag += '迟到, 早退'
              } else if (obj.is_late) {
                tag += '迟到'
              } else if (obj.is_leave_early) {
                tag += '早退'
              } else {
                tag += '已到';
              }
            }
            if(!obj.absence_reason&&obj.absence_comment){
              tag += '('+obj.absence_comment+')'
            }
          } else {
            tag += '-';
          }
        }

        days.push({ day: i + 1, should_clock_on: obj.should_clock_on, tag, is_absence: obj.is_absence });
      }
    }
    return days;
  }

  toolStartDays(year, month) {
    return new Date(year + '-' + month.toString().padStart(2, '0') + '-' + '01').getDay()
  }

  // callbackDay(year, month, day) {
  //   let { setAttendance, editAttendance } = this.props;
  //   if (day.should_clock_on || editAttendance) {
  //     this.props.callbackDay(year, month, day.day, day.should_clock_on);
  //   }
  // }

  callbackDay(year, month, day, should_clock_on) {
    let { setAttendance, editAttendance } = this.props;
    if (editAttendance && (setAttendance || (!setAttendance && should_clock_on))) {
      this.props.callbackDay(year, month, day.day, day.should_clock_on);
    }
  }

  // 渲染日历月份
  _renderCalendarMonth(month, index) {
    let emptyDays = Array.from({ length: month.start_week }, (v, k) => k);
    let { setAttendance } = this.props;
    return (
      <div className="calendar-month" key={index}>
        <div className="calendar-month-header">
          <span className="calendar-month-label">{month.month}月</span> <span>{month.year}</span>
        </div>
        <div className={"calendar-days" + (setAttendance ? ' set-attendance-day' : ' write-attendance-day')}>
          {emptyDays.map((day, key) => <div className="empty-grid" key={key}></div>)}
          {month.days.map((day, key) => <div className="empty-grid" key={key}>
            {setAttendance ? this._renderSetAttendance(month.year, month.month, day, key) : this._renderWriteAttendance(month.year, month.month, day, key)}
          </div>)}
          </div>
      </div>
    )
  }

  // 设置日历
  _renderSetAttendance(year, month, day, key) {
    // console.log(key)
    let { editAttendance } = this.props;

    return (
      <div className={"day-grid" + (editAttendance ? (day.should_clock_on ? ' selected-grid' : ' unselected-grid') : '')} onClick={this.callbackDay.bind(this, year, month, day, day.should_clock_on)}>
        <div className="day-label">{day.day}</div>
        <div className="grid-description">{day.should_clock_on ? <Icon type="check-circle" className="check-circle-icon" /> : '-'}</div>
      </div>
    )
  }

  // 考勤状态查看和修改
  // _renderWriteAttendance(year, month, day, key) {
  //   let { editAttendance } = this.props;
  //   return (
  //     <div className={"day-grid" + (day.should_clock_on ? (editAttendance ? ' edit-grid' : '') : ' unselected-grid')} onClick={this.callbackDay.bind(this, year, month, day, day.should_clock_on)}>
  //       <div className="day-label">{day.day}</div>
  //       <div>{day.tag ? day.tag : '-'}</div>
  //       <div className="grid-operation">修改</div>
  //     </div>
  //   )
  // }

  _renderWriteAttendance(year, month, day, key) {
    let { editAttendance } = this.props;
    const style = {
      color: 'red',
    };
    return (
      <div className={"day-grid" + (editAttendance ? (day.should_clock_on ? ' edit-grid' : ' unselected-grid') : '')} onClick={this.callbackDay.bind(this, year, month, day, day.should_clock_on)}>
        <div className="day-label">{day.day}</div>
        <div style={day.is_absence ? style : {}}>{day.tag ? day.tag : '-'}</div>
        <div className="grid-operation">修改</div>
      </div>
    )
  }

  render() {
    const week_names = ['日', '一', '二', '三', '四', '五', '六'];
    return (
      <div className="attendance-calendar-container">
        <div className="calendar-weeks">
          {week_names.map((week_name, index) => <div className="week-name" key={index}>{week_name}</div>)}
        </div>
        <div className="calendar-months-container">
          {this.state.calendar.map((month, index) => this._renderCalendarMonth(month, index))}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/AttendanceCalendar.jsx